<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useBreakpoints } from '@vueuse/core'
import { application_breakpoints } from '@/service/service_breakpoints'
import { Toaster } from 'vue-sonner'

const breakpoints = useBreakpoints(application_breakpoints)
const activeBreakpoint = breakpoints.active()
</script>

<template>
  <Toaster />
  <RouterView :class="activeBreakpoint" />
</template>

<style scoped></style>
